export const POP_STATE = {
  OFF: 0,
  ON: 1,
};

export const POP_STATE_OPTIONS = [
  { value: POP_STATE.ON, label: '發布' },
  { value: POP_STATE.OFF, label: '下架' },
];

export const EN_LANG_CODE = 'en_US';

export function formatPopState(state) {
  return state === POP_STATE.ON ? '發布' : '下架';
}

export function emptyPopDetail(lang) {
  return {
    lang,
    title: '',
    body: '',
    image: '',
  };
}

export function mergePopDetailsWithLanguages(languages, existingDetails = []) {
  const langEntries = [];
  const seen = new Set();

  (languages || []).forEach((lang) => {
    const code = lang.code || lang;
    if (!code || seen.has(code)) {
      return;
    }
    seen.add(code);
    langEntries.push({
      code,
      label: lang.label || code,
    });
  });

  (existingDetails || []).forEach((item) => {
    if (!item?.lang || seen.has(item.lang)) {
      return;
    }
    seen.add(item.lang);
    langEntries.push({
      code: item.lang,
      label: item.lang,
    });
  });

  const map = new Map((existingDetails || []).map((item) => [item.lang, { ...item }]));
  return langEntries.map(({ code, label }) => {
    const found = map.get(code);
    return found
      ? { ...found, lang: code, _label: label }
      : { ...emptyPopDetail(code), _label: label };
  });
}

export function stripPopDetails(details) {
  return (details || []).map(({ lang, title, body, image }) => ({
    lang,
    title: title || '',
    body: body || '',
    image: image || '',
  }));
}

export function hasPopDetailContent(detail) {
  return Boolean(detail?.title?.trim() || detail?.body?.trim() || detail?.image?.trim());
}

export function findDetailByLang(details, langCode) {
  return (details || []).find((item) => item.lang === langCode);
}
